<template>
    <div class="animated fadeIn vld-parent" style="height: 100%; background-color: rgba(223,243,249,0.69)">
        <b-row>
            <b-col>
                <div style="background: rgb(251, 251, 251); padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                        <b-row>
                            <b-col>
                                <b-button variant="primary" v-on:click="onSave" class="px-4 float-right" >Speichern</b-button>
                                <b-button variant="primary" v-on:click="onBack" class="px-4 float-right mr-3" >Zurück</b-button>
                            </b-col>
                        </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 37px; padding-left: 30px; padding-right: 30px">
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Entwicklungsphase</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-table ref="table_growing_state" thead-class="hidden_header" selected-variant="primary" selectable select-mode="multi" striped hover responsive="sm" :items="growing_state"
                                 :fields="fields"
                                 @row-selected="onRowSelectedGrowingState">
                        </b-table>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Sicherheitserwartung</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-table ref="table_security_expectation" thead-class="hidden_header" selected-variant="primary" selectable select-mode="multi" striped hover responsive="sm" :items="security_expectation"
                                 :fields="fields"
                                 @row-selected="onRowSelectedSecurityExpectation">
                        </b-table>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Zustand</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-table ref="table_condition" thead-class="hidden_header" selected-variant="primary" selectable select-mode="multi" striped hover responsive="sm" :items="condition"
                                 :fields="fields"
                                 @row-selected="onRowSelectedCondition">
                        </b-table>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 2px solid lightgray;">
                        <span class="font-lg"><b>Kontrollintervall</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-table ref="table_control_interval" thead-class="hidden_header" selected-variant="primary" selectable select-mode="single" striped hover responsive="sm" :items="control_interval"
                                 :fields="fields"
                                 @row-selected="onRowSelectedControlInterval">
                        </b-table>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";

    export default {
        name: "IntervalRelation",
        mounted() {
            this.showLoader();
            this.id = parseInt(this.$route.params.id);
            this.$http.get(
                Server_URL+'/baumkontrolle/config/interval_relation/'+this.$route.params.id
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                loader: undefined,
                security_expectation: [],
                growing_state: [],
                condition: [],
                control_interval: [],
                fields: [
                    {key: 'text', label:""}
                ],
                interval_relation: null,
                selection_security_expectation: [],
                selection_growing_state: [],
                selection_condition: [],
                selection_control_interval: [],
                id: 0,
            }
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.security_expectation = response.body.constants_security_expectation;
                    this.growing_state = response.body.constants_growing_state;
                    this.condition = response.body.constants_condition;
                    this.control_interval = response.body.constants_control_interval;
                    this.interval_relation = response.body.interval_relation;
                    if (this.$route.params.id !== 0) {
                        setTimeout(() => {
                            let splits = this.interval_relation.security_expectation.split("|");
                            for (let i = 0; i < splits.length; i++) {
                                let current = splits[i];
                                if (current !== "") {
                                    let id = parseInt(current);
                                    for (let j = 0; j < this.security_expectation.length; j++) {
                                        if (this.security_expectation[j].id === id) {
                                            this.$refs.table_security_expectation.selectRow(j);
                                            break;
                                        }
                                    }
                                }
                            }

                            splits = this.interval_relation.growing_state.split("|");
                            for (let i = 0; i < splits.length; i++) {
                                let current = splits[i];
                                if (current !== "") {
                                    let id = parseInt(current);
                                    for (let j = 0; j < this.growing_state.length; j++) {
                                        if (this.growing_state[j].id === id) {
                                            this.$refs.table_growing_state.selectRow(j);
                                            break;
                                        }
                                    }
                                }
                            }

                            splits = this.interval_relation.condition.split("|");
                            for (let i = 0; i < splits.length; i++) {
                                let current = splits[i];
                                if (current !== "") {
                                    let id = parseInt(current);
                                    for (let j = 0; j < this.condition.length; j++) {
                                        if (this.condition[j].id === id) {
                                            this.$refs.table_condition.selectRow(j);
                                            break;
                                        }
                                    }
                                }
                            }

                            let id = this.interval_relation.control_interval;
                            for (let j = 0; j < this.control_interval.length; j++) {
                                if (this.control_interval[j].id === id) {
                                    this.$refs.table_control_interval.selectRow(j);
                                    break;
                                }
                            }
                        });
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkPost(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.onBack();
                } else {
                    console.log(response);
                }
            },
            onSave() {

                let sec = "";
                for (let i = 0; i < this.selection_security_expectation.length; i++) {
                    sec += "|"+this.selection_security_expectation[i].id+"|";
                }
                let grow = "";
                for (let i = 0; i < this.selection_growing_state.length; i++) {
                    grow += "|"+this.selection_growing_state[i].id+"|";
                }
                let condition = "";
                for (let i = 0; i < this.selection_condition.length; i++) {
                    condition += "|"+this.selection_condition[i].id+"|";
                }
                let cont = 0;
                if (this.selection_control_interval.length !== 0) {
                    cont = this.selection_control_interval[0].id;
                }

                this.$http.post(
                    Server_URL+'/baumkontrolle/config/interval_relation',
                    {
                        id: this.id,
                        security_expectation: sec,
                        growing_state: grow,
                        condition: condition,
                        control_interval: cont
                    }
                ).then(this.responseOkPost, this.responseError)
            },
            onBack() {
                this.$router.go(-1);
            },
            onRowSelectedGrowingState(items) {
                this.selection_growing_state = items;
            },
            onRowSelectedSecurityExpectation(items) {
                this.selection_security_expectation = items;
            },
            onRowSelectedCondition(items) {
                this.selection_condition = items;
            },
            onRowSelectedControlInterval(items) {
                this.selection_control_interval = items;
            },
        }
    }
</script>

<style scoped>
    @import '../../../node_modules/vue-material/dist/vue-material.min.css';
</style>
<style>
    .hidden_header {
        display: none;
    }
</style>
